/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Recipes_Bulk_Delete_TitleInputs */

const en_recipes_bulk_delete_title = /** @type {(inputs: Recipes_Bulk_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.count} recipes?`)
};

const de_recipes_bulk_delete_title = /** @type {(inputs: Recipes_Bulk_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Rezepte löschen?`)
};

/**
* | output |
* | --- |
* | "Delete {count} recipes?" |
*
* @param {Recipes_Bulk_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_bulk_delete_title = /** @type {((inputs: Recipes_Bulk_Delete_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_Bulk_Delete_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_bulk_delete_title(inputs)
	return en_recipes_bulk_delete_title(inputs)
});